<template>
  <div class="big import-manage">
    <div class="search_box">
      <div class="item">
        <span class="itemtitle">导入时间</span>
        <el-date-picker
          v-model="importManageForm.import_time"
          type="daterange"
          align="right"
          size="small"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 230px"
          @change="search"
        >
        </el-date-picker>
      </div>

      <div class="item">
        <span class="itemtitle">商品名称</span>
        <el-input
          v-model="importManageForm.goods_name"
          clearable
          style="width: 180px"
          size="small"
          maxlength="30"
          placeholder="请输入"
          @change="search"
        ></el-input>
        <el-button
          type="primary"
          style="margin-left: 20px"
          size="small"
          @click="search"
          >查询</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 20px"
          size="small"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1674') : false
          "
          @click="addEvaluationBtn"
          >新增评价</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 20px"
          size="small"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1676') : false
          "
          @click="importDoctorBtn"
          >导入</el-button
        >
      </div>
    </div>
    <div style="border: solid 1px #c9cbd6">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">
            <div v-if="item.prop == 'number'">
              {{ scope.$index + 1 }}
            </div>

            <div v-else-if="item.prop == 'create_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else-if="item.prop == 'import_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              @click="lookDetail(scope.row.ev_id)"
              >查看</el-button
            >
            <el-button
              type="text"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1675') : false
              "
              @click="delbtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      v-show="totalNum > 0"
      :total="totalNum"
      :page.sync="pagination.page"
      :limit.sync="pagination.pageNumber"
      @pagination="getList"
    />
    <!-- 选择商品 -->
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodDia"
      width="800px"
      style="text-align: left"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="big"
    >
      <div class="content">
        <div style="margin: 10px">
          <el-input
            v-model="keywords"
            placeholder="请输入商品"
            size="small"
            maxlength="20"
            style="width: 200px"
          ></el-input>
          <el-button
            type="primary"
            @click="getGoodsList"
            size="small"
            style="margin-left: 20px"
            >查询</el-button
          >
        </div>

        <div class="table_list">
          <el-table
            ref="multipleTable"
            :data="goodslist"
            tooltip-effect="dark"
            height="500"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="全部商品" width="300">
              <template slot-scope="scope">
                <div class="flex between" style="width: 300px">
                  <el-image
                    :src="scope.row.picture"
                    :preview-src-list="[scope.row.picture]"
                    style="width: 100px; height: 100px"
                  />
                  <div style="width: 180px">
                    <div>{{ scope.row.goods_name }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="规格" width="300">
              <template slot-scope="scope">
                <div v-if="scope.row.open_spec == 1">
                  {{ scope.row.sku_name }}
                </div>
                <div v-else>无</div>
              </template>
            </el-table-column>

            <el-table-column label="店铺名" prop="shop_name"> </el-table-column>

            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="selectGoods(scope.row)"
                  >选择当前商品</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <!-- <pagination
          v-show="goodsTotalNum > 0"
          :total="goodsTotalNum"
          :page.sync="goodsPagination.page"
          :limit.sync="goodsPagination.pageNumber"
          @pagination="getGoodsList"
        /> -->
      </div>
    </el-dialog>

    <!-- 新增评价 -->
    <el-dialog
      title="新增评价"
      :visible.sync="evaluationDia"
      center=""
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      custom-class="evaluationManagement-ImportManage"
    >
      <el-form
        :model="evaluationDiaForm"
        :rules="rules"
        ref="evaluationDiaRef"
        label-width="100px"
        class="form-box"
      >
        <el-form-item label="评价商品" prop="goods_name">
          <div style="display: flex">
            <el-input
              v-model="evaluationDiaForm.goods_name"
              disabled
              size="small"
              style="width: 300px"
            ></el-input>
            <el-button type="text" @click="editGoods">修改商品</el-button>
          </div>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nick_name">
          <el-input
            v-model="evaluationDiaForm.nick_name"
            size="small"
            :maxlength="20"
            style="width: 300px"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品评分" prop="goods_evaluate">
          <el-input-number
            v-model="evaluationDiaForm.goods_evaluate"
            size="small"
            :min="0.1"
            :max="5"
            :precision="1"
            :controls="false"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="物流评分" prop="logistics_evaluate">
          <el-input-number
            v-model="evaluationDiaForm.logistics_evaluate"
            size="small"
            :min="0.1"
            :max="5"
            :precision="1"
            :controls="false"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="服务态度" prop="shop_evaluate">
          <el-input-number
            v-model="evaluationDiaForm.shop_evaluate"
            size="small"
            :min="0.1"
            :max="5"
            :precision="1"
            :controls="false"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="评价时间" prop="create_time">
          <el-date-picker
            v-model="evaluationDiaForm.create_time"
            type="date"
            size="small"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="评价内容" prop="evaluate_content">
          <el-input
            type="textarea"
            v-model="evaluationDiaForm.evaluate_content"
            :rows="2"
            :maxlength="500"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="上传图片"
          prop="evaluate_image"
          class="evaluate-image"
        >
          <div class="box">
            <div
              v-for="(item, index) in evaluationDiaForm.evaluate_image"
              :key="index"
            >
              <UploadImg
                :f_thumb="item.pic"
                :f_thumb_str="item.path"
                :index="index"
                :isCompress="true"
                @emitImg="emitImg"
              ></UploadImg>
            </div>
          </div>
          <div class="prompt">请上传jpg png格式，建议尺寸710x204</div>
        </el-form-item>

        <el-form-item
          label="上传视频"
          prop="evaluate_video"
          class="evaluate-video"
        >
          <UploadVideo
            videoBaseUrl=""
            :videos="evaluationDiaForm.evaluate_video"
            :isUploadCover="true"
            @change="uploadVideoBtn"
            @uploadCover="uploadCover"
          >
            <div class="prompt">请上传MP4格式，建议5M内。</div>
          </UploadVideo>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="evaluationDia = false">取 消</el-button>
        <el-button type="primary" @click="confirmEvaluationDiaBtn"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 评价详情 -->
    <details-dialog
      :type="2"
      :detailsDia.sync="detailsDia"
      :info="detailsInfo"
      :is_audit="1"
    ></details-dialog>
    <!-- 从excel导入 -->
    <import-excel
      :isFlag="isImport"
      interfaceName="importEvaluate"
      paramsKey="excel_url"
      temName="import_evaluate_template"
      @refreshList="getList"
      :description="description"
    ></import-excel>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import shoppingmall from "@/api/shoppingmall.js";
import Pagination from "@/components/Pagination/index";
import ChooseGood from "@/components/chooseGood/index";
import UploadImg from "@/components/uploadImg/index";
import UploadVideo from "@/components/uploadVideo/index";
import DetailsDialog from "./components/detailsDialog.vue";
import ImportExcel from "@/components/importExcel/index.vue";
export default {
  components: {
    Pagination,
    ChooseGood,
    UploadImg,
    UploadVideo,
    DetailsDialog,
    ImportExcel,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7;
        },
      },
      description: `
                      <div>评价导入不可导入用户头像、评价图片及视频，用户头像为系统随机匹配</div>
                      <div>请按照导出格式完整填写数据后导入，否则无法导入</div>
                      <div>错误数据可对照文件行数修改数据后重新导入</div>
                      <div>最多导入5000条，导入需要时间，请耐心等待</div>
                    `,
      tableLoading: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      importManageForm: {
        import_time: "",
        goods_name: "",
      },
      tableHeader: [
        {
          label: "序号",
          prop: "number",
          width: "50",
          align: "center",
          fixed: "left",
        },
        {
          label: "商品名称",
          prop: "goods_name",
          width: "200",
          align: "center",
          fixed: "left",
        },
        {
          label: "规格名称",
          prop: "sku_name",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "用户昵称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "商品评分",
          prop: "goods_evaluate",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "评价内容",
          prop: "evaluate_content",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "物流评分",
          prop: "logistics_evaluate",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "服务态度",
          prop: "shop_evaluate",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "评价时间",
          prop: "create_time",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "导入时间",
          prop: "import_time",
          width: "160",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      evaluationDia: false,
      evaluationDiaForm: {
        goods_id: "",
        goods_name: "",
        sku_id: "",
        nick_name: "",
        goods_evaluate: undefined,
        logistics_evaluate: undefined,
        shop_evaluate: undefined,
        create_time: "",
        evaluate_content: "",
        evaluate_image: [
          {
            pic: "",
            path: "",
          },
        ],
        evaluate_video_image: "",
        evaluate_video: [],
      },
      rules: {
        goods_name: [{ required: true, message: "请选择", trigger: "change" }],
        nick_name: [{ required: true, message: "请输入", trigger: "blur" }],

        goods_evaluate: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        logistics_evaluate: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        shop_evaluate: [{ required: true, message: "请输入", trigger: "blur" }],
        create_time: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      chooseGoodDia: false,
      keywords: "",
      //   goodsTotalNum: 0,
      goodsPagination: {
        page: 1,
        pageNumber: 999999999,
      },
      goodslist: [],
      detailsDia: false,
      detailsInfo: {},
      isImport: false,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getGoodsList();
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.importManageForm, this.pagination);
      params = _.omit(params, ["buy_time"]);
      if (
        this.importManageForm.import_time &&
        this.importManageForm.import_time.length
      ) {
        params.import_time_start = this.importManageForm.import_time[0];
        params.import_time_end = this.importManageForm.import_time[1];
      }

      this.tableLoading = true;
      shoppingmall.getExploreEvaluateList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    delbtn(row) {
      this.$confirm("确定删除改数据吗 ？", `提示`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let params = {
            ev_id: row.ev_id,
          };
          shoppingmall.delEvaluate(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("删除成功");
              this.search();
            }
          });
        })
        .catch(() => {});
    },
    lookDetail(ev_id) {
      const loading = this.$loading();
      shoppingmall
        .getUserOrderEvaluateInfo({ ev_id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.detailsInfo = data.info;
            this.detailsDia = true;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 新增评价---start
    // 获取商品
    getGoodsList() {
      let params = Object.assign(
        { keywords: this.keywords },
        this.goodsPagination
      );
      this.axios
        .post("platform/shop/getShopActivityGoodsList", params)
        .then((res) => {
          let { data } = res;
          this.goodslist = data.list;

          let list = [];
          data.list.map((item) => {
            if (item.sku_list.length) {
              for (let skuItem of item.sku_list) {
                item = Object.assign({}, item, skuItem);
                list.push(item);
              }
            } else {
              list.push(item);
            }
          });
          this.goodslist = list;
        });
    },
    selectGoods(data) {
      let { goods_id, goods_name, sku_id } = data;
      this.evaluationDiaForm.goods_id = goods_id;
      this.evaluationDiaForm.goods_name = goods_name;
      this.evaluationDiaForm.sku_id = sku_id;
      this.chooseGoodDia = false;
      this.evaluationDia = true;
    },
    addEvaluationBtn() {
      this.chooseGoodDia = true;
      this.restForm();
    },
    editGoods() {
      this.chooseGoodDia = true;
      this.evaluationDia = false;
      this.restForm();
    },
    emitImg(data, index, isDel) {
      if (isDel) {
        this.evaluationDiaForm.evaluate_image.splice(index, 1);
        this.evaluationDiaForm.evaluate_image.push({
          pic: "",
          path: "",
        });
        return;
      }
      this.evaluationDiaForm.evaluate_image[index].pic = data.pic;
      this.evaluationDiaForm.evaluate_image[index].path = data.path;
      if (this.evaluationDiaForm.evaluate_image.length < 8) {
        this.evaluationDiaForm.evaluate_image.push({
          pic: "",
          path: "",
        });
      }
    },
    // 视频
    uploadVideoBtn(list) {
      this.evaluationDiaForm.evaluate_video = list;
    },
    // 视频封面
    uploadCover(data) {
      this.evaluationDiaForm.evaluate_video_image = data.pic;
    },
    // 提交评价
    confirmEvaluationDiaBtn() {
      this.$refs["evaluationDiaRef"].validate((valid) => {
        if (valid) {
          let params = _.omit(this.evaluationDiaForm, [
            "evaluate_image",
            "evaluate_video",
            "goods_name",
          ]);
          params.evaluate_image = this.evaluationDiaForm.evaluate_image
            .map((item) => item.pic)
            .join(",");
          params.evaluate_image = params.evaluate_image.substring(
            0,
            params.evaluate_image.lastIndexOf(",")
          );
          params.evaluate_video = this.evaluationDiaForm.evaluate_video
            .map((item) => item.video_url)
            .join(",");
          let loading = this.$loading();
          shoppingmall
            .creattExploreEvaluate(params)
            .then((res) => {
              let { code, data } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.evaluationDia = false;
                this.getList();
              }
              loading.close();
            })
            .catch(() => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清空表单
    restForm() {
      this.evaluationDiaForm = {
        goods_id: "",
        goods_name: "",
        sku_id: "",
        nick_name: "",
        goods_evaluate: undefined,
        logistics_evaluate: undefined,
        shop_evaluate: undefined,
        create_time: "",
        evaluate_content: "",
        evaluate_image: [
          {
            pic: "",
            path: "",
          },
        ],
        evaluate_video_image: "",
        evaluate_video: [],
      };
    },
    // 新增评价---end
    // 导入
    importDoctorBtn() {
      this.isImport = !this.isImport;
    },
  },
};
</script>

<style lang="scss" scoped>
.search_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .itemtitle {
      display: inline-block;
      width: 65px;
      margin-right: 8px;
      text-align: right;
    }
  }
}
</style>
<style lang="scss">
.evaluationManagement-ImportManage {
  .form-box {
    padding: 20px;
    .el-form-item__content {
      width: 100%;
      margin-left: 0 !important;
      text-align: left;
    }
    .el-form-item {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .el-input {
      width: 100%;
    }
  }
  .evaluate-image {
    .el-form-item__content {
      height: auto;
      .box {
        display: flex;
        flex-wrap: wrap;

        & > div {
          margin-right: 4px;
        }
      }
    }
  }
  .evaluate-video {
    .el-form-item__content {
      height: auto;
    }
  }
}
.prompt {
  color: #c9cbd6;
}
</style>
